export type PageIds = {
    [key in 'menu' | 'content' | 'footer']: string;
};

export const pageIds: PageIds = {
    menu: 'menu-navigation',
    content: 'main-content',
    footer: 'footer'
};